import React from 'react';
import { gifts } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Bonuses() {
  return <section className="px-5 pb-6 pt-14 sm:px-6 md:px-8" data-id="element-10" data-mp="pjg4xyy2x3zv">
      <div className="mx-auto max-w-[640px]" data-id="element-11" data-mp="avlbggc8yvlq">
        <SectionHeading eyebrow="Buying today, you also get…" data-id="element-12" data-mp="aujwi0s41oyq">+8 free bonuses</SectionHeading>
        <p className="mt-2.5 text-center text-[15.5px] leading-[1.6] text-ink-500" data-id="element-13" data-mp="fslgqp19vubs">
          Included with every edition.
        </p>
      </div>

      <ul className="mx-auto mt-9 grid max-w-[980px] grid-cols-2 gap-x-4 gap-y-8 md:grid-cols-4 md:gap-x-6 md:gap-y-10" data-id="element-14" data-mp="5vqkydwdw817">
        {gifts.map(gift => <li key={gift.label} data-id="element-15" data-mp="3o36aqjjht8id">
            <div className="overflow-hidden rounded-xl border border-cream-300 bg-white p-1 shadow-card" data-id="element-16" data-mp="3o3y21i624k2u">
              <img src={gift.image} alt={`Cover of ${gift.title}`} className="block w-full rounded-lg" width={1092} height={1456} loading="lazy" decoding="async" data-id="element-17" data-mp="1ma8l0wl0iw1n" />
            </div>

            <p className="mt-3 font-display text-[11.5px] font-semibold uppercase tracking-[0.14em] text-teal-500" data-id="element-18" data-mp="3dfldf5r7cw1f">
              {gift.label}
            </p>
            <p className="mt-1 font-display text-[15.5px] font-semibold leading-[1.3] text-ink-900" data-id="element-19" data-mp="3r5ykz706m8q8">
              {gift.title}
            </p>
            <p className="mt-1 text-[13.5px] leading-[1.45] text-ink-500" data-id="element-20" data-mp="2zf29oatrsc52">{gift.subtitle}</p>
          </li>)}
      </ul>
    </section>;
}